<template>
  <div class="search-administrators container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">{{ title }}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }}</li>
            </ol>
        </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form v-on:submit.prevent class="form-material">
              <div class="row">
                <div class="col-md-3 col-lg-3 p-0">
                  <div class="m-3">
                    <label class="search-label">Email</label>
                    <input v-model="email" class="form-control" placeholder="Email" style="width:100%" type="text">
                  </div>
                </div>
                <div class="col-md-2 col-lg-3 p-0">
                  <div class="m-3">
                    <label class="search-label">First Name</label>
                    <input v-model="name_first" class="form-control" placeholder="First Name" style="width:100%" type="text">
                  </div>
                </div>
                <div class="col-md-2 col-lg-3 p-0">
                  <div class="m-3">
                    <label class="search-label">Last Name</label>
                    <input v-model="name_last" class="form-control" placeholder="Last Name" style="width:100%" type="text">
                  </div>
                </div>
                <div class="col-md-2 col-lg-3 p-0">
                  <div class="m-3">
                    <label class="search-label">Password</label>
                    <input v-model="password" class="form-control" placeholder="Password" style="width:100%" type="password" id="passwordInput">
                    <button v-on:click="togglePass()" class="btn btn-info waves-effect waves-light m-t-5">Show Password</button>
                  </div>
                </div>
                <div class="col-md-2 col-lg-3 m-3 p-0" style="min-width: 300px;">
                  <label class="search-label">User Type</label>
                  <div class="form-check">
                    <input class="form-check-input" id="new_admin_radio" type="radio" value="admin" name="input" v-model="role">
                    <label class="form-check-label" for="new_admin_radio">
                      Admin
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" id="new_agent_radio" type="radio" value="agent" name="input" v-model="role">
                    <label class="form-check-label" for="new_agent_radio">
                      Agent
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" id="new_accounting_radio" type="radio" value="accounting" name="input" v-model="role">
                    <label class="form-check-label" for="new_accounting_radio">
                      Accounting
                    </label>
                  </div>
                  <br>
                  <div v-if="role == 'accounting'">
                    <div class="m-3">
                      <label class="search-label">Market</label>
                      <select type="text" placeholder="Market"
                              class="form-control ddown" id="market-filter" v-model="selected_market">
                        <option v-bind:value="'All'">
                          All
                        </option>
                        <option v-for="market in markets" v-bind:value="market.id_market">
                          {{ market.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-2 m-3 p-0 submit-button">
                  <button v-on:click="addAdmin()" class="btn btn-info waves-effect waves-light m-t-10">Add</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="result">
              <div class="">
                <div class="table-responsive">
                  <form v-on:submit.prevent>
                    <table class="table table-sm table-hover">
                      <thead>
                        <tr>
                          <!--<th class="text-center result-label">ID</th>-->
                          <th class="result-label">Email</th>
                          <th class="result-label">First Name</th>
                          <th class="result-label">Last Name</th>
                          <th class="result-label">User Type</th>
                          <th class="result-label">Market</th>
                          <th class="result-label"></th>
                        </tr>
                      </thead>
                      <tbody class="col-12">
                      <tr v-for="(admin, index) in data">
                        <td class="result-item">
                          <div v-show="admin.edit == false">
                            <span>
                              {{ admin.email }}
                            </span>
                          </div>

                          <input v-model="admin.email" v-show = "admin.edit == true" class="form-control" placeholder="Email" style="width:100%" type="text">
                        </td>
                        <td class="result-item">
                          <div v-show="admin.edit == false">
                            <span>
                              {{ admin.name_first }}
                            </span>
                          </div>
                          <input v-model="admin.name_first" v-show = "admin.edit == true" class="form-control" placeholder="First name" style="width:100%" type="text">
                        </td>
                        <td class="result-item">
                          <div v-show="admin.edit == false">
                            <span>
                              {{ admin.name_last }}
                            </span>
                          </div>
                          <input v-model="admin.name_last" v-show = "admin.edit == true" class="form-control" placeholder="Last name" style="width:100%" type="text">
                        </td>
                        <td class="result-item">
                          <!--{{ admin.is_staff ? (admin.is_superuser ? 'superuser': 'admin') : '' }} {{ admin.is_agent ? 'agent' : '' }}-->
                          <div v-if="roles[index] === 'admin' || roles[index] === 'agent' || roles[index] === 'accounting'">
                            <div class="form-check">
                              <input class="form-check-input" :id="admin.id_user + '_admin_radio'"  type="radio" value="admin" v-bind:name="index" v-model="roles[index]" v-on:change="changeRole(admin, index)">
                              <label class="form-check-label" :for="admin.id_user + '_admin_radio'">
                                Admin
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" :id="admin.id_user + '_agent_radio'"  type="radio" value="agent" v-bind:name="index" v-model="roles[index]" v-on:change="changeRole(admin, index)">
                              <label class="form-check-label" :for="admin.id_user + '_agent_radio'">
                                Agent
                              </label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" :id="admin.id_user + '_accounting_radio'"  type="radio" value="accounting" v-bind:name="index" v-model="roles[index]" v-on:change="changeRole(admin, index)">
                              <label class="form-check-label" :for="admin.id_user + '_accounting_radio'">
                                Accounting
                              </label>
                            </div>
                          </div>

                          <div v-if="roles[index] === 'superuser'">
                            Superuser
                          </div>
                        </td>
                        <td class="result-item">
                          <div v-show="admin.edit == false">
                            <span>
                              {{ admin.id_market && admin.id_market.name ? admin.id_market.name : 'All' }}
                            </span>
                          </div>
                          <!--<input v-model="admin.id_market" v-show = "admin.edit == true" class="form-control" placeholder="Market" style="width:100%" type="text">-->
                          <select type="text" placeholder="Market"
                                  class="form-control ddown" v-model="admin.id_market" v-show = "admin.edit == true">
                            <option v-bind:value="null">
                              All
                            </option>
                            <option v-for="market in markets" v-bind:value="market.id_market">
                              {{ market.name }}
                            </option>
                          </select>
                        </td>
                        <td class="result-item">
                          <font-awesome-icon v-if="admin.edit==false" @click="admin.edit=true; restore(previousAdmin); changePreviousAdmin(admin); backup(admin);" icon="edit" style="color: #26a69a; cursor: pointer"/>
                          <font-awesome-icon v-if="admin.edit==true" @click="updateAdmin(admin);" icon="check" style="color: #26a69a; cursor: pointer"/>
                          <font-awesome-icon v-if="admin.edit==true" @click="admin.edit=false; restore(admin);" icon="times" style="color: #ef5350; cursor: pointer"/>
                          <font-awesome-icon v-if="roles[index]!='superuser' && getUser('id_user') != admin.id_user" @click="deleteAdmin(admin);" icon="trash-alt" style="color: #ef5350; cursor: pointer"/>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </form>

                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                    <span v-else>Showing 0 entries</span>
                  </div>

                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Settings',
    },
    name: 'Settings',
    data () {
      return {
        title: 'Settings',
        previousAdmin: null,
        data: {},
        email: '',
        name_first: null,
        name_last: null,
        password: null,
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        roles: [],
        role: 'admin',
        input_admin:null,
        errors: null,
        non_field_errors: null,
        field_name: {
          'name_first': 'First Name',
          'name_last': 'Last Name',
          'password': 'Password',
          'email': 'Email',
        },
        email_bk: null,
        name_first_bk: null,
        name_last_bk: null,
        id_market_bk: null,
        markets: null,
        selected_market: 'All'
      }
    },
    components: {
      Loading
    },
    methods: {
      changePreviousAdmin(admin) {
        if (this.previousAdmin) {
          this.previousAdmin.edit = false
        }
        this.previousAdmin = admin
      },
      search: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'users/?type=admin_search&page=' + (page ? page : this.currentPage))
          .then(response => {
            console.log(response.data)

            for( let index in response.data.results) {
              response.data.results[index]['edit'] = false
            }

            this.data = response.data.results

            this.roles = []
            for (let index in this.data) {
              if (this.data[index].is_superuser) {
                this.roles.push("superuser")
              } else {
                this.roles.push((this.data[index].is_admin ? 'admin' : this.data[index].is_agent ? 'agent' : 'accounting'))
              }
            }
            console.log('roles ', this.roles)

            if (response.data && response.data.count) {
              this.totalRows = response.data.count
            }
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      buttonSearch (page) {
        this.resetPager()
        this.search(page)
      },
      changePage: function (page) {
        console.log('change to page: ' + page)
        this.search(page)
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      backup(admin) {
        console.log('email_bk', this.email_bk, admin.email)
        console.log('backup', this.id_market_bk, admin.id_market)
        this.email_bk = admin.email
        this.name_first_bk = admin.name_first
        this.name_last_bk = admin.name_last
        this.id_market_bk = admin.id_market
      },
      restore(admin) {
        if (!admin) {
          return
        }
        admin.name_first = this.name_first_bk
        admin.name_last = this.name_last_bk
        admin.email = this.email_bk
        admin.id_market = this.id_market_bk
      },
      updateAdmin(admin) {
        // partial update
        this.isLoading = true
        console.log('selected market: ', admin.id_market)
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'users/' + admin.id_user + '/?type=update_admin', {
            email: admin.email.replace('\n', '').trim(),
            name_first: !admin.name_first ? '' : admin.name_first.replace('\n', '').trim(),
            name_last: !admin.name_last ? '' : admin.name_last.replace('\n', '').trim(),
            id_market: admin.id_market == 'null' ? '' : admin.id_market
          })
          .then(response => {
            console.log(response.data)

            this.backup(response.data)

            admin.edit = false

            // update list
            this.search()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)

            error = error.response.data
            if ('non_field_errors' in error) {
              error = error['non_field_errors'][0]
            } else {
              if (Array.isArray(error)) {
                error = error[0]
              } else {
                let name = Object.keys(error)[0]
                error = error[name][0].replace('This field', this.field_name[name])
                error = error.replace('this field', this.field_name[name])
                error = error.replace('Enter a valid email address.', 'Invalid email address.')
              }
            }

            this.showToastError(error)
          })
          .finally()
      },
      addAdmin() {
        // if (this.email.indexOf('@') == -1 || this.email.indexOf('.') == -1) {
        //   alert('please enter a valid email')
        //   return
        // }

        this.isLoading = true
        var params = {
          email: this.email,
          username: this.email,
          id_booking_organization: null,
          name_first: this.name_first,
          name_last: this.name_last,
          password: this.password,
          is_admin: this.role == 'admin',
          is_agent: this.role == 'agent',
        }
        if (this.selected_market !== 'All') {
          console.log('selected market: ', this.selected_market)
          params['id_market'] = this.selected_market
        }
        this.$http
          .post(process.env.API_BASE_URL_CS + 'users/?type=create_admin', params)
          .then(response => {
            console.log(response.data)

            this.email = ''
            this.name_first = ''
            this.name_last = ''
            this.password = ''
            this.selected_market = 'All'
            this.role = 'admin'

            // update list
            this.search()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)

            this.isLoading = false

            error = error.response.data
            if ('non_field_errors' in error) {
              error = error['non_field_errors'][0]
            } else {
              let name = Object.keys(error)[0]
              error = error[name][0].replace('This field', this.field_name[name])
              error = error.replace('this field', this.field_name[name])
              error = error.replace('Enter a valid email address.', 'Invalid email address.')
            }

            this.showToastError(error)
          })
      },
      changeRole(admin, index) {
        // partial update
        this.isLoading = true
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'users/' + admin.id_user + '/?type=update_admin_role', {
            is_admin: this.roles[index] == 'admin',
            is_agent: this.roles[index] == 'agent'
          })
          .then(response => {
            console.log(response.data)
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      deleteAdmin(admin) {
        if(!confirm("Are you sure you want to remove this user?")) {
          return
        }

        this.isLoading = true
        this.$http
          .patch(process.env.API_BASE_URL_CS + 'users/' + admin.id_user + '/?type=delete_admin', {})
          .then(response => {
            console.log(response.data)

            // update list
            this.search()
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            console.log(error.response)
            this.errored = true
            this.isLoading = false
          })
      },
      togglePass() {
        var x = document.getElementById("passwordInput");
        if (x.type === "password") {
          x.type = "text";
        } else {
          x.type = "password";
        }
      },
      getMarkets: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'markets/')
          .then(response => {
            console.log('markets response', response.data)
            this.markets = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
      },
    },
    mounted () {
      console.log("Mounted")
      this.search()
      this.getMarkets()
    },
    created () {
      // document.title = "Wingz Support | Settings";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }

  .add-admin-btn {
    color: #333268;
    background-color: #00f9b9;
    border: none;
    margin-left: 5px;
  }

  .add-admin-btn:hover {
    background-color: red;
  }

  .add-admin-panel {
    max-width: 400px;
  }
  .form-check {
    display: inline-block;
    padding-left: 0px;
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue